export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recipient:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User is not found"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacts"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Choice"])}
}